import * as React from "react";
import AppBar from "@mui/material/AppBar";
import Box from "@mui/material/Box";
import Toolbar from "@mui/material/Toolbar";
import IconButton from "@mui/material/IconButton";
import Typography from "@mui/material/Typography";
import Menu from "@mui/material/Menu";
import MenuIcon from "@mui/icons-material/Menu";
import Container from "@mui/material/Container";
import Button from "@mui/material/Button";
import MenuItem from "@mui/material/MenuItem";
import Logo from "assets/img/logo.svg";
import {FormControl, Select, useTheme} from "@mui/material";
import {useState, useEffect} from "react";
import {useWeb3React} from "@web3-react/core";
import {
    Facebook,
    Instagram,
    LinkedIn,
    Twitter,
    YouTube,
} from "@mui/icons-material";
import {shortenAddress} from "@usedapp/core";
import {InjectedConnector} from "@web3-react/injected-connector";
import Web3 from "web3";
import {Link, Events, scrollSpy} from 'react-scroll'
import {toast} from "react-toastify";
import {useHistory, useParams} from "react-router-dom";

const Header = () => {
    const [anchorElNav, setAnchorElNav] = React.useState(null);
    const theme = useTheme();
    const history = useHistory();
    const [lang, setLang] = useState("EN");
    const [showMyTokens,setShowMyTokens] = useState(false);
    const {active, chainId, account, activate, deactivate, library, connector} =
        useWeb3React();
    useEffect(() => {
        Events.scrollEvent.register('begin', function (to, element) {
            // console.log('begin', arguments);
        });

        Events.scrollEvent.register('end', function (to, element) {
            // console.log('end', arguments);
            // handleClose();
            handleCloseNavMenu();
            if(to == 'tokens')
                setShowMyTokens(true);
        });
        scrollSpy.update();
        return () => {
            Events.scrollEvent.remove('begin');
            Events.scrollEvent.remove('end');
        }
    }, []);
    useEffect(()=>{
        if(showMyTokens){
            showMyPixels();
            setShowMyTokens(false);
        }
    },[showMyTokens])
    useEffect(async () => {
        if (account && chainId != (process.env.REACT_APP_MODE == 'TEST' ? 3 : 1)) {
            if (window.ethereum) {
                window.web3 = new Web3(window.ethereum);
            }
            await window.web3.currentProvider.request({
                method: "wallet_switchEthereumChain",
                params: [{chainId: process.env.REACT_APP_MODE == 'TEST' ? "0x3" : "0x1"}]
            });
        }
    }, [account, chainId])
    const handleOpenNavMenu = (event) => {
        setAnchorElNav(event.currentTarget);
    };
    const handleCloseNavMenu = () => {
        setAnchorElNav(null);
    };
    const handleChange = (event) => {
        setLang(event.target.value);
    };
    const handleConnect = async (e) => {
        e.preventDefault();
        const injectedConnector = new InjectedConnector({});
        if (!active) {
            try {
                activate(injectedConnector);
            } catch (ex) {
                console.log(ex);
            }
        } else {
            try {
                deactivate();
            } catch (ex) {
                console.log(ex);
            }
        }
    };
    const showMyPixels = ()=>{
        if(!account){
            toast.warning('Please connect wallet!');
            return;
        } else{
            history.push(`/owner/${account}`)
        }
    }
    return (
        <AppBar
            position="static"
            color="default"
            sx={{
                backgroundImage: "none",
                backgroundColor: theme.palette.background.default,
            }}
        >
            <Container maxWidth="xl">
                <Toolbar disableGutters>
                    <Box sx={{display: {md: "flex", lg: "none"}}}>
                        <IconButton
                            size="large"
                            aria-label="account of current user"
                            aria-controls="menu-appbar"
                            aria-haspopup="true"
                            onClick={handleOpenNavMenu}
                            color="inherit"
                        >
                            <MenuIcon/>
                        </IconButton>
                        <Menu
                            id="menu-appbar"
                            anchorEl={anchorElNav}
                            anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                            }}
                            keepMounted
                            transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                            }}
                            open={Boolean(anchorElNav)}
                            onClose={handleCloseNavMenu}
                            sx={{
                                display: {md: "block", lg: "none"},
                                width: {xs: "100%", sm: "auto"},
                            }}
                        >
                            <MenuItem>
                                <Link activeClass="active" to="howtoworks" spy={true} smooth={true} offset={-110}
                                      duration={500}>
                                    HOW IT WORKS?
                                </Link>
                            </MenuItem>
                            <MenuItem>
                                <Link activeClass="active" to="tokens" spy={true} smooth={true} offset={-110}
                                      duration={500}>
                                    MY PIXELS
                                </Link>

                            </MenuItem>
                            <MenuItem>
                                <Link activeClass="active" to="home" spy={true} smooth={true} offset={-110}
                                      duration={500}>
                                    REFERRAL PROGRAM
                                </Link>
                            </MenuItem>
                            <Box
                                sx={{
                                    mx: 1,
                                    display: {sm: "block", md: "none"},
                                }}
                            >
                                <IconButton size="small" component="span">
                                    <Facebook/>
                                </IconButton>
                                <IconButton size="small" component="span">
                                    <Twitter/>
                                </IconButton>
                                <IconButton size="small" component="span">
                                    <Instagram/>
                                </IconButton>
                                <IconButton size="small" component="span">
                                    <LinkedIn/>
                                </IconButton>
                                <IconButton size="small" component="span">
                                    <YouTube/>
                                </IconButton>
                            </Box>
                            <Box
                                sx={{
                                    mx: 1,
                                    display: {xs: "block", sm: "none"},
                                }}
                            >
                                <FormControl
                                    variant="standard"
                                    sx={{m: 1, maxWidth: 60, minWidth: 60}}
                                >
                                    <Select
                                        labelId="demo-simple-select-standard-label"
                                        value={lang}
                                        style={{borderBottom: "none"}}
                                        onChange={handleChange}
                                        className="lang_selection"
                                        label="Age"
                                        sx={{paddingLeft: "7px"}}
                                    >
                                        <MenuItem value="EN">EN</MenuItem>
                                        <MenuItem value="CH">CH</MenuItem>
                                    </Select>
                                </FormControl>
                            </Box>
                        </Menu>
                    </Box>
                    <Box sx={{display: "flex", flexGrow: {xs: 1, sm: 0}}}>
                        <img src={Logo} className="logoImg"/>
                    </Box>
                    <Box sx={{flexGrow: 1, display: {xs: "none", sm: "flex"}}}>
                        <FormControl
                            variant="standard"
                            sx={{m: 2, maxWidth: 50, minWidth: 50}}
                        >
                            <Select
                                labelId="demo-simple-select-standard-label"
                                id="demo-simple-select-standard"
                                value={lang}
                                style={{borderBottom: "none"}}
                                onChange={handleChange}
                                className="lang_selection"
                                label="Age"
                                sx={{paddingLeft: "7px"}}
                            >
                                <MenuItem value="EN">
                                    <Typography sx={{mt: "2px", fontSize: "12px"}}>
                                        EN
                                    </Typography>
                                </MenuItem>
                                <MenuItem value="CH">
                                    <Typography sx={{fontSize: "12px"}}>CH</Typography>
                                </MenuItem>
                            </Select>
                        </FormControl>
                    </Box>
                    <Box sx={{flexGrow: 1, display: {xs: "none", lg: "flex"}}}>
                        <Link activeClass="active" to="howtoworks" spy={true} smooth={true} offset={-110}
                              duration={500}>
                            <Button color="inherit" sx={{my: 2, color: "white", display: "block"}}>
                                HOW IT WORKS?
                            </Button>
                        </Link>
                        <Link activeClass="active" to="tokens" spy={true} smooth={true} offset={200}
                              duration={500}>
                            <Button color="inherit" sx={{my: 2, color: "white", display: "block"}}>
                                    MY PIXELS
                            </Button>
                        </Link>

                        <Link activeClass="active" to="home" spy={true} smooth={true} offset={-110}
                              duration={500}>
                            <Button color="inherit" sx={{my: 2, color: "white", display: "block"}}>
                                Referral program
                            </Button>
                        </Link>
                    </Box>
                    <Box sx={{flexGrow: {xs: 0, md: 0, lg: 1}}}>
                        <Button
                            variant="contained"
                            size="small"

                            onClick={(e) => handleConnect(e)}
                            // onClick={activateBrowserWallet}
                            sx={{my: 2, px: 1, borderRadius: "20px", width: "150px"}}
                        >
                            {active ? shortenAddress(account) : "Connect Wallet"}
                        </Button>
                    </Box>
                    <Box
                        sx={{
                            ml: 1,
                            flexGrow: {xs: 0, md: 0, lg: 1},
                            display: {xs: "none", md: "flex"},
                        }}
                    >
                        <IconButton size="small" component="span">
                            <Facebook/>
                        </IconButton>
                        <IconButton size="small" component="span">
                            <Twitter/>
                        </IconButton>
                        <IconButton size="small" component="span">
                            <Instagram/>
                        </IconButton>
                        <IconButton size="small" component="span">
                            <LinkedIn/>
                        </IconButton>
                        <IconButton size="small" component="span">
                            <YouTube/>
                        </IconButton>
                    </Box>
                </Toolbar>
            </Container>
        </AppBar>
    );
};
export default Header;
